import { render, staticRenderFns } from "./RsaSchedaOspiteUsciteListComponent.vue?vue&type=template&id=64ce298a&scoped=true"
import script from "./RsaSchedaOspiteUsciteListComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaOspiteUsciteListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaOspiteUsciteListComponent.vue?vue&type=style&index=0&id=64ce298a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce298a",
  null
  
)

export default component.exports